module.exports = __webpack_public_path__ + "static/media/kocka2POLIGLOT.64678cab.png";